import { appAxios } from "@/core/utils/appAxios";
import {
    APIResponse,
    OrderDto,
    PostOrderPickupDateRequestBody,
} from "@/shared/api-contract/api-contract";
import { Vue } from "vue-class-component";
import { Emit, Model, Prop } from "vue-property-decorator";

export class ConfirmDatePopup extends Vue {
    @Model("_order", { required: true })
    order!: OrderDto;
    @Model("_vehiclesId", { required: true, default: ["113312"] })
    vehiclesId!: string[];
    @Model("_formattedDate", { required: true, default: new Date() })
    formattedDate!: Date;
    isOpen = true;

    @Emit("closeConfirmPopup")
    closeConfirmPopup(isSuccess) {
        this.$emit("closeConfirmPopup", {
            isSuccess,
        });
        this.isOpen = false;
    }

    confirmHandle() {
        const millisecondsSinceEpoch =
            this.formattedDate.getTime() - new Date(0).getTime();

        const daysSinceEpoch = Math.floor(
            millisecondsSinceEpoch / (24 * 60 * 60 * 1000),
        ).toString();

        // const date = Math.floor(this.formattedDate.getTime() / 1000).toString();
        this.fetchConfirmDate(this.order.id.toString(), this.vehiclesId, daysSinceEpoch);
    }
    get localFormatDate() {
        return this.formattedDate.toLocaleDateString();
    }
    /* API Connectivity --------------------------------------------------------------------------------------------- */
    fetchConfirmDate = async (
        orderId: string,
        ids_order_vehicles: string[],
        date: string,
    ) => {
        const payload: PostOrderPickupDateRequestBody = {
            date,
            ids_order_vehicles,
        };

        appAxios.value
            .post<APIResponse<void[]>>(
                `/client/web/orders/${orderId}/pickup-date`,
                payload,
            )
            .then((resp) => {
                const isSuccess = resp.data.status.code === 200;
                this.closeConfirmPopup(isSuccess);
            })
            .catch((res) =>
                console.log(`Fetch pickup-date Order #${orderId} error:`, res),
            );
    };
}
